import View from './View'


const Container = () => {

   return(<View title="Novo Cliente" />)
}

export default Container
